import { useEffect } from 'react';
import { getComponentNameByGatewayId } from "../../util/components";
import { dispatch } from '@wordpress/data'
import { PAYONEER_STORE_KEY } from "../../store/index";
/**
 * @see https://developer.woocommerce.com/2022/10/06/how-the-checkout-block-processes-an-order/
 * @see https://developer.woocommerce.com/docs/cart-and-checkout-payment-method-integration-for-the-checkout-block/#3-props-fed-to-payment-method-nodes
 */
export const Component = function (
	{
		payWithPayoneer,
		initPayoneerComponents,
		paymentMethodData,
		rebootPayoneer,
		activePaymentMethod,
		eventRegistration,
		isValid
	}
) {

	const { onPaymentSetup, onCheckoutSuccess, onCheckoutFail } = eventRegistration;
	/**
	 * Ping the SDK when we see the light of day
	 */
	useEffect( () => {
		initPayoneerComponents()
	}, [] )

	useEffect( () => {
		return onCheckoutSuccess( ({orderId}) => {
			dispatch(PAYONEER_STORE_KEY).setOrderId(orderId);
			payWithPayoneer();
		} );
	}, [] );

	useEffect( () => {
		return onCheckoutFail( rebootPayoneer );
	}, [] );
	/**
	 * Enhance the payment data validation step.
	 * We need to validate that the LIST used in block checkout submit
	 * matches the one we will use for finalizing the transaction in the backend.
	 * Therefore, we pass additional metadata in this listener
	 */
	useEffect( () => {
		return onPaymentSetup( () => {
			return isValid
				?
				{
					type: 'success',
				}
				:
				{
					type: 'failure',
					message: 'Invalid payment fields',
				}
		} );
	}, [ isValid, onPaymentSetup, paymentMethodData ] );

	const componentName = getComponentNameByGatewayId( activePaymentMethod );

	return <div
		className={`payment_method_${activePaymentMethod}`}
		data-component={componentName}
	></div>;
}
